import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";
import User from "./modules/UserStore";
import Const from "./modules/ConstStore";
import AppSetting from "./modules/AppSettingStore";
import Filter from "./modules/FilterStore";
import VueClipboard from "vue-clipboard2";

Vue.use(VueClipboard);
Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    User,
    Const,
    AppSetting,
    Filter,
  },
  plugins: [createPersistedState()],
});
